import type { CSSProperties, ReactNode } from "react"
export function BigHeading({
  children,
  variant = "h2",
  color,
}: {
  children: ReactNode
  variant?: "h1" | "h2" | "h3"
  color?: string
}) {
  const Heading = variant
  return (
    <Heading
      className={`big-heading relative z-[-1] mt-[-1vw] ml-0 max-w-[60vw] p-0 text-left text-[var(--heading-color,var(--blue))] uppercase not-italic leading-[1em] opacity-50 [animation:enterAnimation_1s_ease-out_1] ${
        variant === "h3" ? "text-[length:max(4vw,2.5rem)]" : "text-[length:max(8vw,5rem)]"
      } ${variant === "h1" ? "mb-0" : ""}`}
      data-testid="big-heading"
      style={color ? ({ "--heading-color": color } as CSSProperties) : undefined}
    >
      {children}
    </Heading>
  )
}

export default BigHeading
